namespace TabAurous.ECommerce {
    export interface ECommSalesReceiptRow {
        ReceiptId?: number;
        TransId?: number;
        ModeId?: number;
        LedgerId?: number;
        Code?: string;
        Amount?: number;
        RefNo?: string;
        ChequeNo?: number;
        ChequeDate?: string;
        Scheme?: string;
        Total?: number;
        Balance?: number;
        RefTransId?: number;
        RefVoucherType?: number;
        SchemeEnrollmentId?: number;
        BankId?: number;
    }

    export namespace ECommSalesReceiptRow {
        export const idProperty = 'ReceiptId';
        export const nameProperty = 'RefNo';
        export const localTextPrefix = 'ECommerce.ECommSalesReceipt';
        export const deletePermission = 'EComm:ECommSales:Delete';
        export const insertPermission = 'EComm:ECommSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommSales:Edit';

        export declare const enum Fields {
            ReceiptId = "ReceiptId",
            TransId = "TransId",
            ModeId = "ModeId",
            LedgerId = "LedgerId",
            Code = "Code",
            Amount = "Amount",
            RefNo = "RefNo",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Scheme = "Scheme",
            Total = "Total",
            Balance = "Balance",
            RefTransId = "RefTransId",
            RefVoucherType = "RefVoucherType",
            SchemeEnrollmentId = "SchemeEnrollmentId",
            BankId = "BankId"
        }
    }
}
